// Global Instructions Rule Applied!

export const SET_GLOBAL_CONFIGS = 'global_configs/SET_GLOBAL_CONFIGS' as const
export const CLEAR_GLOBAL_CONFIGS_DATA = 'global_configs/CLEAR_GLOBAL_CONFIGS_DATA' as const
export const REMOVE_USER_PREFERENCE_FOR_MENU_ITEM = 'global_configs/REMOVE_USER_PREFERENCE_FOR_MENU_ITEM' as const
export const MERGE_USER_PREFERENCE_ROW_DATA = 'global_configs/MERGE_USER_PREFERENCE_ROW_DATA' as const
export const SET_USER_PREFERENCES_APP_DATA = 'global_configs/SET_USER_PREFERENCES_APP_DATA' as const
export const UPDATE_GLOBAL_CONFIG_FUND = 'global_configs/UPDATE_GLOBAL_CONFIG_FUND' as const
export const ADD_GLOBAL_CONFIG_FUND = 'global_configs/ADD_GLOBAL_CONFIG_FUND' as const
